import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
  CustomLaborData,
  OptionalItemsState,
  ProductId,
} from './optionalItems.types';

const initialState: OptionalItemsState = {
  selectedOptionalItemId: undefined,
  selectedOptionalItems: {},
  selectedCustomLaborOptionalItems: {},
  selectedWarrantyProductId: undefined,
};

const optionalItemSlice = createSlice({
  name: 'optionalItem',
  initialState,
  reducers: {
    selectWarrantyProduct: (state, action: PayloadAction<number>) => {
      state.selectedOptionalItemId = action.payload;
      state.selectedWarrantyProductId = action.payload;
    },
    clearSelectedWarrantyProduct: (state) => {
      state.selectedOptionalItemId = undefined;
      state.selectedWarrantyProductId = undefined;
    },
    /**Action payload: is number id */
    selectOptionalItem: (state, action: PayloadAction<ProductId>) => {
      state.selectedOptionalItemId = action.payload;
      state.selectedOptionalItems[action.payload] = 1;
    },
    deselectOptionalItem: (state, action: PayloadAction<ProductId>) => {
      state.selectedOptionalItemId = undefined;
      state.selectedOptionalItems[action.payload] = 0;
    },
    addOneOptionalItem: (state, action: PayloadAction<ProductId>) => {
      const qty = state.selectedOptionalItems[action.payload] ?? 0;

      state.selectedOptionalItemId = action.payload;
      state.selectedOptionalItems[action.payload] = qty + 1;
    },
    removeOneOptionalItem: (state, action: PayloadAction<ProductId>) => {
      const qty = state.selectedOptionalItems[action.payload] ?? 0;

      state.selectedOptionalItemId = action.payload;
      state.selectedOptionalItems[action.payload] = Math.max(qty - 1, 0);
    },
    setOptionalItemQuantity: (
      state,
      {
        payload: { productId, quantity },
      }: PayloadAction<{ productId: ProductId; quantity: number }>
    ) => {
      state.selectedOptionalItems[productId] = quantity;
    },
    setOptionalItemsMap: (
      state,
      { payload }: PayloadAction<OptionalItemsState['selectedOptionalItems']>
    ) => {
      state.selectedOptionalItems = payload;
    },
    resetOptionalItems: (state) => {
      state.selectedOptionalItems = initialState.selectedOptionalItems;
    },
    setCustomLaborOptionalItemsForProduct: (
      state,
      action: PayloadAction<{
        productId: ProductId;
        customLaborOptionalItems: CustomLaborData[];
      }>
    ) => {
      state.selectedCustomLaborOptionalItems = {
        ...state.selectedCustomLaborOptionalItems,
        [action.payload.productId]: action.payload.customLaborOptionalItems,
      };
    },
    resetCustomLaborOptionalItemsForProduct: (
      state,
      action: PayloadAction<ProductId>
    ) => {
      state.selectedCustomLaborOptionalItems = {
        ...state.selectedCustomLaborOptionalItems,
        [action.payload]: [],
      };
    },
    resetCustomLaborOptionalItems: (state) => {
      state.selectedCustomLaborOptionalItems =
        initialState.selectedCustomLaborOptionalItems;
    },
  },
});

export const {
  addOneOptionalItem,
  removeOneOptionalItem,
  setOptionalItemQuantity,
  selectOptionalItem,
  deselectOptionalItem,
  // START Warranty Products
  selectWarrantyProduct,
  clearSelectedWarrantyProduct,
  // END Warranty Products
  // START Custom Labor
  setCustomLaborOptionalItemsForProduct,
  resetCustomLaborOptionalItemsForProduct,
  // END Custom Labor
  setOptionalItemsMap,
  resetOptionalItems,
  resetCustomLaborOptionalItems,
} = optionalItemSlice.actions;

export default optionalItemSlice.reducer;
